import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '*',
            component: () => import('@/components/404'),
            meta: {
                roles: ['stu', 'teach']
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/page/login/login.vue'),
            meta: {
                roles: ['stu', 'teach', 'NoValidation']
            }
        },
        {
            path: '/loading',
            name: 'loading',
            component: () => import('@/page/login/loading.vue'),
            meta: {
                roles: ['stu', 'teach', 'NoValidation']
            }
        },
        {
            path: '/index',
            component: () => import('@/page/Public/Index/index.vue'),
            meta: {
                roles: ['stu', 'teach', 'NoValidation']
            },
            children: [
                {
                    path: 'home',//首页
                    name: "home",
                    components: {
                        default: () => import('@/page/Public/Home/home.vue'),
                    },
                    meta: {
                        roles: ['stu', 'teach', 'NoValidation'],
                        navType: 'home',
                        footerType: 1,
                        aiChatPageType: 'home'
                    }
                },
                {
                    path: 'moreList/:type',//首页
                    name: "moreList",
                    components: {
                        default: () => import('@/page/Public/Home/moreList.vue'),
                    },
                    meta: {
                        roles: ['stu', 'teach', 'NoValidation'],
                        navType: 'courseList',
                        footerType: 1,
                        aiChatPageType: 'home'
                    }
                },
                {
                    path: 'exchangeList',
                    name: "exchangeList",
                    components: {
                        default: () => import('@/page/Public/Exchange/exchangeList.vue'),
                    },
                    meta: {
                        roles: ['stu', 'teach', 'NoValidation'],
                        navType: 'exchange'
                    }
                },
                {
                    path: 'exchangeDetail/:bbsid',
                    name: "exchangeDetail",
                    components: {
                        default: () => import('@/page/Public/Exchange/exchangeDetail.vue'),
                    },
                    meta: {
                        roles: ['stu', 'teach', 'NoValidation'],
                        navType: 'exchange'
                    }
                },
                {
                    path: 'collectionList',
                    name: "collectionList",
                    components: {
                        default: () => import('@/page/Public/Exchange/collectionList.vue'),
                    },
                    meta: {
                        roles: ['stu', 'teach'],
                        navType: 'exchange'
                    }
                },


                {
                    path: 'personal',
                    name: "Personal",
                    components: {
                        default: () => import('@/page/Personal/personal.vue'),
                    },
                    meta: {
                        roles: ['stu', 'teach'],
                        navType: 'teachSpace'
                    }
                },
                {
                    path: 'classList', //学生-加入班级
                    name: "classList",
                    components: {
                        default: () => import('@/page/Public/ClassManagement/Students/classList.vue'),
                    },
                    meta: {
                        roles: ['stu', 'teach'],
                        navType: 'classList'
                    }
                },
                {
                    path: 'classDetail/:spaceid',//学生 - 能力测验 - 班级详细
                    name: "classDetail",
                    components: {
                        default: () => import('@/page/Public/ClassManagement/Students/classDetail.vue'),
                    },
                    meta: {
                        roles: ['stu', 'teach', 'NoValidation'],
                        navType: 'classList',
                        aiChatPageType: 'space_detail'
                    }
                },
                {
                    path: 'classManagement',
                    name: "classManagement",
                    components: {
                        default: () => import('@/page/Public/ClassManagement/Teachers/classList.vue'),
                    },
                    meta: {
                        roles: ['teach'],
                        navType: 'teachSpace'
                    }
                },
                {
                    path: 'classManagementDetail/:spaceid',
                    name: "classManagementDetail",
                    components: {
                        default: () => import('@/page/Public/ClassManagement/Teachers/classDetail.vue'),
                    },
                    meta: {
                        roles: ['teach'],
                        navType: 'teachSpace',
                        aiChatPageType: 'teacher_space_detail'
                    }
                },
                // 能力评估
                {
                    path: 'capabilityAssessment',
                    name: 'capabilityAssessment',
                    components: {
                        default: () => import('@/page/Public/capabilityAssessment/capabilityAssessment.vue'),
                    },
                    meta: {
                        roles: ['stu', 'teach'],
                        navType: 'teachSpace'
                    }
                },
                {
                    path: 'courseDetail/:type/:spaceid/:subid/:ispreview?',
                    name: "courseDetail",
                    components: {
                        default: () => import('@/page/Public/CoursePack/courseDetail.vue'),
                    },
                    meta: {
                        roles: ['stu', 'teach', 'NoValidation'],
                        navType: 'teachSpace',
                        aiChatPageType: 'space_detail'
                    }
                },

                {
                    path: 'organizationList',
                    name: "organizationList",
                    components: {
                        default: () => import('@/page/Public/Organization/organizationList.vue'),
                    },
                    meta: {
                        roles: ['stu', 'teach', 'NoValidation'],
                        navType: 'organization'
                    }
                },
                {
                    path: 'courseOverview/:spaceid/:subid/:uid',//mooc 学习成绩列详细页
                    name: "courseOverview",
                    component: () => import('@/page/Public/ClassManagement/Teachers/courseOverview.vue'),
                    meta: {
                        roles: ['stu', 'teach'],
                        navType: 'teachSpace'
                    }
                },
                {
                    path: 'settled',
                    name: 'settled',
                    component: () => import('@/page/Public/settled/settled.vue'),
                    meta: {
                        roles: ['stu', 'teach', 'NoValidation'],
                        navType: 'settled'
                    }
                },
                {
                    path: '/',
                    redirect: 'home',//设置默认指向的路径
                }
            ]
        },
        {
            path: '/cesu',//测速页面
            component: () => import('@/page/Public/cesu/index.vue'),
            meta: {
                roles: ['teach', 'stu', 'NoValidation']
            },
        },

        {
            path: '/courseOj/:bind_subject_id/:sccid/',//mooc空间-OJ编程页面
            component: () => import('@/page/Public/CoursePack/courseOj.vue'),
            meta: {
                roles: ['teach', 'stu']
            },
        },
        {
            path: '/shareExperiment',//实验任务
            component: () => import('@/page/Public/CoursePack/shareExperiment.vue'),
            meta: {
                roles: ['teach', 'stu', 'NoValidation'],
            },
        },

        {
            path: '/invite',
            component: () => import('@/page/Public/ClassManagement/Students/invites.vue'),
            meta: {
                roles: ['stu', 'teach', 'NoValidation']
            },
        },
        {
            path: '/organizationDetail/:schoolid',
            name: "organizationDetail",
            component: () => import('@/page/Public/Organization/organizationDetail.vue'),
            meta: {
                roles: ['NoValidation'],
            }
        },
        {
            path: '/courseVideo/:spaceid/:subid/:sccid/:ispreview?',//mooc空间-视频课程页面 ispreview 1为预览
            name: 'courseVideo',
            component: () => import('@/page/Public/CoursePack/coursePlay.vue'),
            meta: {
                roles: ['stu', 'teach'],
                aiChatPageType: 'task_detail'
            },
        },
        {
            path: '/coursePDF/:spaceid/:subid/:sccid/:ispreview?',//mooc空间-视频课程页面 ispreview 1为预览
            component: () => import('@/page/Public/CoursePack/coursePdf.vue'),
            meta: {
                roles: ['stu', 'teach']
            },
        },
        {
            path: '/courseTask/:spaceid/:subid/:sccid/:ispreview?',//mooc空间-实验任务页面
            name: 'courseTask',
            component: () => import('@/page/Public/CoursePack/enterExperiment.vue'),
            meta: {
                roles: ['teach', 'stu'],
                aiChatPageType: 'task_detail'
            },
        },
        {
            path: '/coursePaper/:spaceid/:subid/:sccid/:ispreview?',//mooc空间-习题页面
            name: 'coursePaper',
            component: () => import('@/page/Public/CoursePack/coursePaper.vue'),
            meta: {
                roles: ['teach', 'stu'],
                aiChatPageType: 'task_detail'
            },
        },
        {
            path: '/courseHandouts/:spaceid/:subid/:sccid/:ispreview?',//mooc空间-OJ编程页面
            name: 'courseHandouts',
            component: () => import('@/page/Public/CoursePack/courseHandouts.vue'),
            meta: {
                roles: ['teach', 'stu'],
                aiChatPageType: 'task_detail'
            },
        },
        {
            path: '/evaluationReport/:spaceid/:subid/:sccid/:uid?', //习题测验答题报告
            name: "evaluationReport",
            component: () => import('@/page/Public/CoursePack/evaluationReport.vue'),
            meta: {
                roles: ['teach', 'NoValidation'],
                aiChatPageType: 'task_detail'
            }
        },
        {
            path: '/answerDetail/:spaceid/:subid/:sccid/:uid?', ////习题测验答题详细
            name:'answerDetail',
            component: () => import('@/page/Public/CoursePack/aiAnswerDetail.vue'),
            meta: {
                roles: ['teach', 'stu', 'NoValidation'],
                aiChatPageType: 'task_detail'
            },
        },
        {
            path: '/taskReport/:resid/:postid',//实验任务回放页面
            component: () => import('@/page/Public/ClassManagement/Teachers/dialog/taskReport.vue'),
            meta: {
                roles: ['teach'],
            },
        },
        {
            path: '/studyDetail/:spaceid/:subid/:sccid/:uid',//mooc空间-学习成绩详细页面
            component: () => import('@/page/Public/StudyDetail/studyDetail.vue'),
            meta: {
                roles: ['teach'],
            },
        },
        {
            path: '/learnAssessment/:spaceid/:subid/:uid',
            name: "learnAssessment",
            component: () => import('@/page/Public/CoursePack/learnAssessment.vue'),
            meta: {
                roles: ['teach', 'stu'],
            },
        },
        {
            path: '/',
            redirect: '/index',//设置默认指向的路径
        }
    ]
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js